<template>
  <!--  v-if is in case the object model async fetch hasn't been received yet-->
  <loading :loading="!Boolean(handler.endPoint)">
    <template #loading>
      <collapsible-section
        :control-name="dropdownControlId"
        :id="dropdownControlId"
        :is-open="false"
        disabled
        class="collapse-item"
      >
        <template #section-header>
          <xpinner />
        </template>
      </collapsible-section>
    </template>
    <template #loaded>
      <collapsible-section
          class="collapse-item"
          :id="`apiEndPointDataCollapse-${handler.endPoint.client_id}-${dropdownControlId}`"
          control-name="apiEndPointDataCollapse"
          :is-open="isOpen(handler.hasApiEndPointDataMatch('', handler.endPoint, handler.apiMessageType))"
      >
        <template #section-header>
          <row>
            <prefix>
              <icon :glyph="varIOClass(handler.variable)"/>
            </prefix>
            <prefix>
              <icon :glyph="`api`"/>
            </prefix>
            <column>
              {{ handler.rootHeader }}
            </column>
          </row>
        </template>
        <template #section-contents>
          <api-end-point-data
            :handler="handler"
            :q="q"
            :end-point="handler.endPoint"
            :api-message-type="handler.apiMessageType"
            :level="1"
            :path="path"
            default-open
            @select="select"
            :parent-tree-context="computedChildTreeContext"
          ></api-end-point-data>
        </template>
      </collapsible-section>
    </template>
  </loading>
</template>

<script lang="ts">
import Vue from 'vue';
import handlerComponentsMixin from "~/components/dynamicFieldsTrees/mixins/handlerComponentsMixin";
import CollapsibleSection from '~/components/dynamicFieldsTrees/handlerComponents/common/collapsible-section.vue';
import {ReferencePathNode} from "~/models/referencePaths/referencePathNode";
import {ReferenceNodeType} from "~/enums/referenceNodeType";
import handlerTreeContextMixin from '~/components/dynamicFieldsTrees/mixins/handlerTreeContextMixin';
import {IDynamicTreeContext} from '~/interfaces/dynamicFieldsInterfaces';
import DynamicElementMixin from '~/components/dynamicFieldsTrees/handlerComponents/common/dynamic-element-mixin.vue';
import ProcessFlowApiEndPointDynamicFieldsHandler from "~/models/dynamicFields/handlers/processFlows/processFlowApiEndPointDynamicFieldsHandler";
import ApiEndPointData from "~/components/dynamicFieldsTrees/handlerComponents/api-end-point-data.vue";

export default Vue.extend({
  mixins: [handlerComponentsMixin, handlerTreeContextMixin, DynamicElementMixin],
  components: {
    ApiEndPointData,
    CollapsibleSection,
  },
  props: {
    handler: {
      type: Object as () => ProcessFlowApiEndPointDynamicFieldsHandler,
      required: true,
    },
  },
  computed: {
    path(): Array<ReferencePathNode> {
      return [
        new ReferencePathNode(null, {reference_type: ReferenceNodeType.ProcessFlowVariable, reference_id: this.handler.variable.id}),
        new ReferencePathNode(null, {reference_type: ReferenceNodeType.ApiConnection, reference_id: this.handler.endPoint.connection_id}),
        new ReferencePathNode(null, {reference_type: ReferenceNodeType.ApiEndpoint, reference_id: this.handler.endPoint.id}),
      ];
    },
    treeContext(): Partial<IDynamicTreeContext> {
      return {
        isTopLevelCollectionAssigned: false
        // do not send in parent here
      }
    }
  },
});
</script>